"use client";

import { type ReactNode, createContext, useContext } from "react";

type KioskContextValue = {
	isKiosk: boolean;
};

const KioskContext = createContext<KioskContextValue | null>(null);

type KioskProviderProps = {
	children: ReactNode;
	isKiosk?: boolean;
};

export const KioskProvider = ({ children, isKiosk = false }: KioskProviderProps) => {
	return <KioskContext.Provider value={{ isKiosk }}>{children}</KioskContext.Provider>;
};

type UseKioskProps = {
	isKiosk: boolean;
};

export const useKiosk = (): UseKioskProps => {
	const context = useContext(KioskContext);

	if (!context) {
		throw new Error("useKiosk must be used within a KioskProvider");
	}

	return context;
};
